/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Link_MoreInputs */

const en_pol_link_more = /** @type {(inputs: Pol_Link_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the AI provider policy`)
};

const id_pol_link_more = /** @type {(inputs: Pol_Link_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat kebijakan penyedia AI`)
};

/**
* | output |
* | --- |
* | "See the AI provider policy" |
*
* @param {Pol_Link_MoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_link_more = /** @type {((inputs?: Pol_Link_MoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Link_MoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_link_more(inputs)
	return en_pol_link_more(inputs)
});